var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-darkgrey text-center py-2"},[_c('span',[_vm._v(_vm._s(_vm.$t('KNEVersion.version'))+" "+_vm._s(_vm.version))])])}
var staticRenderFns = []
export { render, staticRenderFns }